import { render, staticRenderFns } from "./locationLabel.vue?vue&type=template&id=1d46cdd9&scoped=true&"
import script from "./locationLabel.vue?vue&type=script&lang=ts&"
export * from "./locationLabel.vue?vue&type=script&lang=ts&"
import style0 from "./locationLabel.vue?vue&type=style&index=0&id=1d46cdd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d46cdd9",
  null
  
)

export default component.exports